import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function DeleteUserModal({ modalIsOpen, setModalIsOpen, onConfirmation, userName, userId }) {

    const toggleModel = () => {
        setModalIsOpen(!modalIsOpen);
    };

    return (
        <Modal isOpen={modalIsOpen} toggle={toggleModel}>
            <ModalHeader className="bg-danger text-white">
                <span className="text-white h3">Confrim Delete</span>
            </ModalHeader>
            <ModalBody>Are you sure you want to delete {userName} ?</ModalBody>
            <ModalFooter>
                <Button onClick={toggleModel}>Cancel</Button>
                <Button
                    className="bg-danger text-white"
                    onClick={() => {
                        onConfirmation(userId);
                        // toggleModel();
                    }}>
                    Delete
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteUserModal;